import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../Firebase/authContext";
import "../Home/Card.css";

export default function Card(car) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const auth = useAuth();
  const user = auth.currentUser;
  //  const navigate = useNavigate();

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  const formatMileage = (km) => {
    return new Intl.NumberFormat("en-US").format(km);
  };

  const handleFavoriteClick = (e) => {
    e.preventDefault();
    if (!user) {
      alert("Please log in to add to favorites.");
      // Optionally redirect to login
      // navigate("/login");
      return;
    }

    setIsFavorite(!isFavorite);

    // Optionally: Call backend to save favorite in MongoDB
    // axios.post('/api/favorites', { userId: user.uid, carId: car.id });
  };

  return (
      <Link
        to={`/card-details/${car.RecordNumber}`}
        className="text-decoration-none"
      >
      <div className="card custom-card">
        <div className="image-container">
          {!imageLoaded && <div className="image-skeleton"></div>}
          <img
            src={car.image || "/placeholder.svg"}
            className={`car-img ${imageLoaded ? "loaded" : ""}`}
            alt={car.title}
            onLoad={() => setImageLoaded(true)}
            onError={(e) => {
              e.target.src =
                "https://via.placeholder.com/400x224?text=No+Image";
              setImageLoaded(true);
            }}
          />
          <div className="image-overlay"></div>

         
            {/* <div className="tag-ribbon">
              <span className={`tag-label ${car.tag}`}>
                {car.tag}
              </span>
            </div> */}
          



          <div className="price-tag">{formatPrice(car.price)}</div>

          <button
            className={`favorite-btn ${isFavorite ? "active" : ""}`}
            onClick={handleFavoriteClick}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 
                2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 
                4.5 2.09C13.09 3.81 14.76 3 16.5 3 
                19.58 3 22 5.42 22 8.5c0 3.78-3.4 
                6.86-8.55 11.54L12 21.35z"
              />
            </svg>
          </button>
        </div>

        <div className="card-body">
          <div className="card-header-section">
            <h6 className="card-title">{car.title}</h6>
            <div className="car-badges">
              <span className="year-badge">{car.year}</span>
              <span className="transmission-badge">{car.transmission}</span>
            </div>
          </div>

          <div className="car-details">
            <div className="detail-item">
              <div className="detail-icon fuel-icon">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 
                    2.11c-.94.36-1.61 1.26-1.61 2.33 0 
                    1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 
                    1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5
                    c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v14c0 
                    1.1.9 2 2 2h6c1.1 0 2-.9 2-2v-3h1v5.5c0 
                    1.38 1.12 2.5 2.5 2.5s2.5-1.12 
                    2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 
                    10H6V5h6v5z"
                  />
                </svg>
              </div>
              <span>{car.fuel}</span>
            </div>

            <div className="detail-item">
              <div className="detail-icon mileage-icon">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 
                    13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 
                    9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 
                    2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                  />
                </svg>
              </div>
              <span>{formatMileage(car.km)} km</span>
            </div>
          </div>

          <button className="view-details-btn">
            View Details
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="arrow-icon"
            >
              <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
            </svg>
          </button>
        </div>
      </div>
    </Link>
  );
}


